/**
 * Does a held ability list grant a target ability?
 *
 * The mirror of `RoleService::abilitiesGrant()` on the server, and the only
 * place the front decides it. The backend expands one tier — `contacts` arrives
 * with `contacts.view` and `contacts.manage` beside it — but it cannot expand
 * what it does not enumerate, and two shapes reach the front unexpanded:
 *
 *  - a **wildcard**, `settings.*`, which the plan ceiling hands out to mean
 *    "the plan does not restrict settings";
 *  - an **ancestor written bare**, `settings`, which a role holds to mean every
 *    section of it.
 *
 * Read with a plain `includes()`, both answered no to every real section. An
 * organization whose plan sold part of a module — the only case where a ceiling
 * exists at all — therefore lost its entire settings screen: Organisation,
 * Utilisateurs, Rôles, CRM, Ventes and the email templates all vanished, while
 * the entries gated on `admin` alone stayed. Nothing about its plan was wrong.
 *
 * A gate that answers differently from the endpoint behind it either hides what
 * is permitted or offers what is refused; these are the server's own rules.
 *
 * @param {string[]} held  the abilities the user holds in this organization
 * @param {string} target  the ability being asked for
 * @returns {boolean}
 */
export function abilityGranted(held, target) {
    return held.some(
        ability =>
            ability === '*' ||
            ability === target ||
            (ability.endsWith('.*') && target.startsWith(ability.slice(0, -1))) ||
            target.startsWith(ability + '.')
    );
}
